@if (showWarning()) {
  <div emSidebarTarget class="op-environment-warning uk-text-center">
    <i em-icon="warning"></i>
    <span class="uk-margin-small-left">You are now editing the PRODUCTION environment</span>
    <button type="button" class="uk-button uk-button-default uk-button-small uk-margin-small-left"
      (click)="understand()">I understand</button>
  </div>
}
